import { Routes, Route, Navigate } from 'react-router-dom';

import { EProduct } from '../types/misc.enum';

import { AuthRoutes } from './Auth.routes';
import { PrivateRoutes } from './Private.routes';
import { ProductRoutes } from './Product.routes';

import { Auth } from '../components/pages/Auth';

import { Products } from '../components/pages/Products';
import { Settings } from '../components/pages/Settings';
import { ReportHistory } from '../components/pages/ReportHistory';

import { MBTSScenarios } from '../components/pages/mbts/Scenarios';
import { MBTSPersonas } from '../components/pages/mbts/Personas';
import { MBTSPersonaDetails } from '../components/pages/mbts/PersonaDetails';
import { MBTSChat } from '../components/pages/mbts/Chat';
import { MBTSAnalysis } from '../components/pages/mbts/Analysis';
import { MBTSAnalysisV2 } from '../components/pages/mbts/AnalysisV2';

import { MCSAWelcome } from '../components/pages/mcsa/Welcome';
import { MCSAJourney } from '../components/pages/mcsa/Journey';
import { MCSAReport } from '../components/pages/mcsa/Report';

import { MCSAWelcome as MCSAHtmlWelcome } from '../components/pages/mcsa_html__TBD/Welcome';
import { MCSAJourney as MCSAHtmlJourney } from '../components/pages/mcsa_html__TBD/Journey';
import { MCSAOnboarding as MCSAHtmlOnboarding } from '../components/pages/mcsa_html__TBD/Onboarding';
import { MCSANotificationRush as MCSAHtmlNotificationRush } from '../components/pages/mcsa_html__TBD/NotificationRush';
import { MCSAPhishingHunt as MCSAHtmlPhishingHunt } from '../components/pages/mcsa_html__TBD/PhishingHunt';
import { MCSALinkedinVortex as MCSAHtmlLinkedinVortex } from '../components/pages/mcsa_html__TBD/LinkedinVortex';
import { MCSACyberOracle as MCSAHtmlCyberOracle } from '../components/pages/mcsa_html__TBD/CyberOracle';
import { MCSAQuestionnaire as MCSAHtmlQuestionnaire } from '../components/pages/mcsa_html__TBD/Questionnaire';
import { MCSAResults as MCSAHtmlResults } from '../components/pages/mcsa_html__TBD/Results';

import { AppConfig } from '../config/app.config';

const demoMcsaRoutes = (
    <>
        <Route path="/mcsa" element={<MCSAHtmlWelcome />} />
        <Route path="/mcsa/journey" element={<MCSAHtmlJourney />} />
        <Route path="/mcsa/onboarding" element={<MCSAHtmlOnboarding />} />
        <Route path="/mcsa/notification-rush" element={<MCSAHtmlNotificationRush />} />
        <Route path="/mcsa/phishing-hunt" element={<MCSAHtmlPhishingHunt />} />
        <Route path="/mcsa/linkedin-vortex" element={<MCSAHtmlLinkedinVortex />} />
        <Route path="/mcsa/cyber-oracle" element={<MCSAHtmlCyberOracle />} />
        <Route path="/mcsa/questionnaire" element={<MCSAHtmlQuestionnaire />} />
        <Route path="/mcsa/results" element={<MCSAHtmlResults />} />
    </>
);

const currentMcsaRoutes = (
    <>
        <Route path="/mcsa" element={<MCSAWelcome />} />
        <Route path="/mcsa/journey/*" element={<MCSAJourney />} />
        <Route path="/mcsa/report" element={<MCSAReport />} />
    </>
);

export const NavigationRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Products />} />

            <Route element={<AuthRoutes />}>
                <Route path="/auth" element={<Navigate to={'/auth/sign-in'} replace />} />
                <Route path="/auth/:view" element={<Auth />} />
            </Route>

            <Route element={<PrivateRoutes />}>
                {/* <Route element={<ProductRoutes product={EProduct.MBTS} />}> */}
                <Route path="/mbts/scenarios" element={<MBTSScenarios />} />
                <Route path="/mbts/:scenarioId/personas" element={<MBTSPersonas />} />
                <Route path="/mbts/:scenarioId/persona/:personaId/details" element={<MBTSPersonaDetails />} />
                <Route path="/mbts/:scenarioId/persona/:personaId/conversation/:conversationId" element={<MBTSChat />} />
                <Route path="/mbts/:scenarioId/analysis" element={<MBTSAnalysis />} />
                <Route path="/mbts/:scenarioId/analysis-v2" element={<MBTSAnalysisV2 />} />
                {/* </Route> */}

                <Route element={<ProductRoutes product={EProduct.MCSA} />}>
                    {AppConfig.app.isDemo ? demoMcsaRoutes : currentMcsaRoutes}
                </Route>

                <Route path="/settings" element={<Settings />} />
                <Route path="/report-history" element={<ReportHistory />} />
            </Route>

            <Route path="*" element={<div />} />
        </Routes>
    );
};
